import * as ToasterPlugins from "./toaster.service";
import { BREACKPOINT_DESKTOP } from "../config";
import type { IToasterPlugin } from "../types";

const DesktopToaster = new ToasterPlugins.ToasterDesktop();
const MobileToaster = new ToasterPlugins.ToasterDesktop();

const ToasterMobile: IToasterPlugin = {
  info: MobileToaster.info,
  error: MobileToaster.error,
};

const ToasterDesktop: IToasterPlugin = {
  info: DesktopToaster.info,
  error: DesktopToaster.error,
};

Object.setPrototypeOf(ToasterMobile, MobileToaster)
Object.setPrototypeOf(ToasterDesktop, DesktopToaster)

function useToaster(): IToasterPlugin {
  return window.innerWidth >= BREACKPOINT_DESKTOP
    ? ToasterDesktop
    : ToasterMobile;
}

export { ToasterDesktop, ToasterMobile, useToaster }
